var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"light",class:{normal: !_vm.warn && !_vm.danger, warn: !_vm.danger && _vm.warn, danger: _vm.danger, mini: _vm.mini}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('em',[_c('i')])
}]

export { render, staticRenderFns }